import pastoralLogoMini from "../../assets/images/pastoralLogoMini.png";
import mumulyaLogoMini from "../../assets/images/mumulyaLogoMini.png";
import milkCategoryCoverImage from '../../assets/images/milk/milkCategoryCoverImage.webp'
import milkCategoryCoverImageMobile from '../../assets/images/milk/milkCategoryCoverImageMobile.webp'
import milkImage1 from '../../assets/images/milk/milkImage1.webp'
import categoryMilkAboutImage from '../../assets/images/milk/categoryMilkAboutImage.webp'
import butterCategoryCoverImage from '../../assets/images/butter/butterCategoryCoverImage.webp'
import butterCategoryCoverImageMobile from '../../assets/images/butter/butterCategoryCoverImageMobile.webp'
import categoryButterAboutImage from '../../assets/images/butter/categoryButterAboutImage.webp'
import categoryCraftAboutImage from '../../assets/images/craftProducts//categoryCraftAboutImage.webp'
import fermentedMilkCategoryCoverImage from '../../assets/images/fermentedMilkProducts/fermentedMilkCategoryCoverImage.webp'
import fermentedMilkCategoryCoverImageMobile from '../../assets/images/fermentedMilkProducts/fermentedMilkCategoryCoverImageMobile.webp'
import craftProductsCoverImage from '../../assets/images/craftProducts/craftProductsCoverImage.webp'
import craftProductsCoverImageMobile from '../../assets/images/craftProducts/craftProductsCoverImageMobile.webp'
import fermentedMilkAboutImage from '../../assets/images/fermentedMilkProducts/fermentedMilkAboutImage.webp'
import butterImage1 from '../../assets/images/butter/butter-extra-82-5-fat-pastoral-200g.webp'
import butterImage2 from '../../assets/images/butter/butter-selyanske-72-5-fat-pastoral-200g.webp'
import gheeImage from '../../assets/images/butter/ghee-99-fat-pastoral-200g.webp'
import sourCreamPastoral1 from '../../assets/images/fermentedMilkProducts/sour-cream-30-fat-pastoral-200g.webp'
import sourCreamPastoral2 from '../../assets/images/fermentedMilkProducts/sour-cream-30-fat-pastoral-400g.webp'
import kefirMumulya1 from '../../assets/images/fermentedMilkProducts/kefir-1-fat-mumulya-400g.webp'
import kefirMumulya2 from '../../assets/images/fermentedMilkProducts/kefir-1-fat-mumulya-900g.webp'
import kefirMumulya3 from '../../assets/images/fermentedMilkProducts/kefir-2-5-fat-mumulya-400g.webp'
import kefirMumulya4 from '../../assets/images/fermentedMilkProducts/kefir-2-5-fat-mumulya-900g.webp'
import sourCreamMumulya1 from '../../assets/images/fermentedMilkProducts/sour-cream-15-fat-mumulya-400g.webp'
import sourCreamMumulya2 from '../../assets/images/fermentedMilkProducts/sour-cream-20-fat-mumulya-400g.webp'
import yogurtForestBerries1 from '../../assets/images/fermentedMilkProducts/yogurt-forest-berries-2-5-fat-mumulya-400g.webp'
import yogurtForestBerries2 from '../../assets/images/fermentedMilkProducts/yogurt-forest-berries-2-5-fat-mumulya-115g.webp'
import yogurtPeach1 from '../../assets/images/fermentedMilkProducts/yogurt-peach-2-5-fat-mumulya-400g.webp'
import yogurtPeach2 from '../../assets/images/fermentedMilkProducts/yogurt-peach-2-5-fat-mumulya-115g.webp'
import yogurtStrawberry1 from '../../assets/images/fermentedMilkProducts/yogurt-strawberry-2-5-fat-mumulya-400g.webp'
import yogurtStrawberry2 from '../../assets/images/fermentedMilkProducts/yogurt-strawberry-2-5-fat-mumulya-115g.webp'
import craftProduct1 from '../../assets/images/craftProducts/brynza-spices-olive-oil-vogni-provansu-pastoral-50-fat-550g.webp'
import craftProduct2 from '../../assets/images/craftProducts/brynza-herbs-olive-oil-alpiiski-travy-pastoral-50-fat-550g.webp'
import craftProduct3 from '../../assets/images/craftProducts/brynza-spices-herbs-olive-oil-buket-provansu-pastoral-50-fat-550g.webp'



export const CatalogPages = [
  {
    metaTitle: "Молоко Pastoral та Мумуля",
    metaDescription: "Доманівський маслосирзавод виготовляє пастеризоване молоко під ТМ 'Pastoral' та 'Мумуля'",
    path: "/milk/",
    coverImage: milkCategoryCoverImage,
    coverImageMobile: milkCategoryCoverImageMobile,
    coverTitle: "Молоко Пастеризоване",
    aboutTitle: "Молоко Пастеризоване",
    aboutTexts: [
      'Доманівський маслосирзавод виготовляє пастеризоване молоко під ТМ "Pastoral" та "Мумуля" — це 100% натуральне джерело користі. Ми контролюємо якість сирого молока, фермерські господарства, дотримуємось санітарних норм, а пастеризація забезпечує бактеріологічну чистоту. У нашому молоці збережені природні вітаміни, мінерали та білок.',
      "Наше молоко має ідеальний смак свіжого парного молока, який переносить вас у безтурботну сільську ідилію. Завдяки дбайливій обробці, ми зберігаємо автентичний смак, користь і природну чистоту молока, роблячи його ідеальним. Молоко — перший продукт для людини, тому ми ставимось до нього з повагою то любов’ю.",
    ],
    aboutImage: categoryMilkAboutImage,
    brands: [
      {
        name: "МУМУЛЯ",
        logo: mumulyaLogoMini,
        products: [
          { title: "Молоко питне пастеризоване «Українське» 2,5 % жиру ТМ «МУМУЛЯ» 900 g (г)", image: milkImage1, link: "milk-ukrainian-2-5-fat-mumulya-900g/", },
        ],
      },
    ],
  },
  {
    metaTitle: "Масло вершкове Pastoral",
    metaDescription: "Наше масло – показник якості бренду, тому що – це один із найчутливіших до якості молочних продуктів",
    path: "/butter/",
    coverImage: butterCategoryCoverImage,
    coverImageMobile: butterCategoryCoverImageMobile,
    coverTitle: "Масло вершкове",
    aboutTitle: "Масло вершкове",
    aboutTexts: ["Масло – це подорож у світ справжнього гастрономічного задоволення та французької елегантності. Наше масло – показник якості бренду, тому що – це один із найчутливіших до якості молочних продуктів, адже його склад, смак і текстура напряму залежать від технології виробництва, добору сировини та професіоналізму виробника. ", "Воно із добірних вершків, отриманих із молока від перевірених господарств півдня України. Завдяки європейській технології збивання,  обладнанню, традиціям французької молочної майстерності, масло ТМ «Pastoral» має бездоганну текстуру,  смак та аромат вершків. Наше масло джерело природної енергії та корисних речовин."],
    aboutImage: categoryButterAboutImage,
    brands: [
      {
        name: "PASTORAL",
        logo: pastoralLogoMini,
        products: [
            { title: "Масло солодковершкове екстра 82,5 % жиру ТМ «Pastoral» 200 g (г)", image: butterImage1, link: "butter-extra-82-5-fat-pastoral-200g/", },
            { title: "Масло солодковершкове селянське 72,5 % жиру ТМ «Pastoral» 200 g (г)", image: butterImage2, link: "butter-selyanske-72-5-fat-pastoral-200g/", },
            { title: "Топлене масло  99,0 % жиру ТМ «Pastoral» масло ГХІ 200 g (г)", image: gheeImage, link: "ghee-99-fat-pastoral-200g/", },
          ],
        },
    ],
  },
  {
    metaTitle: "Кисломолочні продукти Pastoral та Мумуля",
    metaDescription: "Доманівський маслосирзавод випускає кисломолочні продукти під ТМ 'Pastoral' та 'Мумуля'",
    path: "/fermented-milk-products/",
    coverImage: fermentedMilkCategoryCoverImage,
    coverImageMobile: fermentedMilkCategoryCoverImageMobile,
    coverTitle: "Кисломолочні продукти",
    aboutTitle: "Кисломолочні продукти",
    aboutTexts: ['Доманівський маслосирзавод випускає кисломолочні продукти під ТМ "Pastoral" та "Мумуля". Це великий вибір кефіру, питних та ложкових йогуртів. Кожен споживач може обрати продукти різної жирності, смаків, але весь цей вибір поєднує одне — природна користь, турбота про ваше здоров’я та легкий смак. Кисломолочні продукти ТМ "Pastoral" та "Мумуля" корисні вмістом білка, пробіотиків, кальцію. Вони сприяють зміцненню імунітету та підтримці здоров’я травної системи.', "Йогурти, кефір та інші наші продукти ідеально підходять для щоденного раціону, додаючи свіжість і різноманітність до вашого меню. Обираючи свої улюблені продукти та бренди від Доманівського маслосирзаводу, пам’ятайте — ми створювали їх із турботою про ваше здоров’я."],
    aboutImage: fermentedMilkAboutImage,
    brands: [
      {
        name: "PASTORAL",
        logo: pastoralLogoMini,
        products: [
            { title: "Сметана 30% жиру ТМ «Pastoral» 200 g (г)", image: sourCreamPastoral1, link: "sour-cream-30-fat-pastoral-200g/", },
            { title: "Сметана 30% жиру ТМ «Pastoral» 400 g (г)", image: sourCreamPastoral2, link: "sour-cream-30-fat-pastoral-400g/", },
          ],
        },
        {
          name: "МУМУЛЯ",
          logo: mumulyaLogoMini,
          products: [
            { title: "Кефір 1,0 % жиру ТМ «МУМУЛЯ» 400 g (г)", image: kefirMumulya1, link: "kefir-1-fat-mumulya-400g/", },
            { title: "Кефір 1,0 % жиру ТМ «МУМУЛЯ» 900 g (г)", image: kefirMumulya2, link: "kefir-1-fat-mumulya-900g/", },
            { title: "Кефір 2,5 % жиру ТМ «МУМУЛЯ» 400 g (г)", image: kefirMumulya3, link: "kefir-2-5-fat-mumulya-400g/", },
            { title: "Кефір 2,5 % жиру ТМ «МУМУЛЯ» 900 g (г)", image: kefirMumulya4, link: "kefir-2-5-fat-mumulya-900g/", },
            { title: "Сметана 15 % жиру ТМ «МУМУЛЯ» 400 g (г)", image: sourCreamMumulya1, link: "sour-cream-15-fat-mumulya-400g/", },
            { title: "Сметана 20 % жиру ТМ «МУМУЛЯ» 400 g (г)", image: sourCreamMumulya2, link: "sour-cream-20-fat-mumulya-400g/", },
            { title: "Йогурт зі шматочками персика 2,5% жиру ТМ «МУМУЛЯ» 400 g (г)", image: yogurtPeach1, link: "yogurt-peach-2-5-fat-mumulya-400g/", },
            { title: "Йогурт зі шматочками персика 2,5% жиру ТМ «МУМУЛЯ» 115 g (г)", image: yogurtPeach2, link: "yogurt-peach-2-5-fat-mumulya-115g/", },
            { title: "Йогурт зі шматочками полуниці 2,5% жиру ТМ «МУМУЛЯ» 400 g (г)", image: yogurtStrawberry1, link: "yogurt-strawberry-2-5-fat-mumulya-400g/", },
            { title: "Йогурт зі шматочками полуниці 2,5% жиру ТМ «МУМУЛЯ» 115 g (г)", image: yogurtStrawberry2, link: "yogurt-strawberry-2-5-fat-mumulya-115g/", },
            { title: "Йогурт зі шматочками лісових ягод 2,5% жиру ТМ «МУМУЛЯ» 400 g (г)", image: yogurtForestBerries1, link: "yogurt-forest-berries-2-5-fat-mumulya-400g/", },
            { title: "Йогурт зі шматочками лісових ягод 2,5% жиру ТМ «МУМУЛЯ» 115 g (г)", image: yogurtForestBerries2, link: "yogurt-forest-berries-2-5-fat-mumulya-115g/", },
          ],
      },
    ],
  },
  {
    metaTitle: "Крафтові продукти Pastoral",
    metaDescription: "Крафтові молочні продукти – це цілий світ смаків і відкриттів",
    path: "/craft-products/",
    coverImage: craftProductsCoverImage,
    coverImageMobile: craftProductsCoverImageMobile,
    coverTitle: "Крафтові продукти",
    aboutTitle: "Крафтові продукти",
    aboutTexts: ["Крафтові молочні продукти – це цілий світ смаків і відкриттів. Вони бувають ніжними та вершковими, легкими з пониженим вмістом жиру, солоними чи солодкими, з додаванням ягід, горіхів, ароматних трав або навіть оливкової олії.", "Ми уважно дослухаємось до ваших побажань і створюємо колекції, що завжди приємно дивують."],
    aboutImage: categoryCraftAboutImage,
    brands: [
      {
        name: "PASTORAL",
        logo: pastoralLogoMini,
        products: [
            { title: "Бринза зі спеціями в оливковій олії «Вогні Провансу» ТМ «Pastoral» 50% жирності в сухій речовині 550 g (г)", image: craftProduct1, link: "brynza-spices-olive-oil-vogni-provansu-pastoral-50-fat-550g/", },
            { title: "Бринза з травами в оливковій олії «Альпійські трави» ТМ «Pastoral» 50% жирності в сухій речовині 550 g (г)", image: craftProduct2, link: "brynza-herbs-olive-oil-alpiiski-travy-pastoral-50-fat-550g/", },
            { title: "Бринза зі спеціями та травами в оливковій олії  «Букет Провансу» ТМ «Pastoral» 50% жирності в сухій речовині 550 g (г)", image: craftProduct3, link: "brynza-spices-herbs-olive-oil-buket-provansu-pastoral-50-fat-550g/", },
          ],
        },
    ],
  },
];
